var focusElement;

function focusLastActiveElement() {
    setTimeout(function () { focusElement.focus(); }, 500);
}

//modal clikc handler
$(".cardListModal_container__child a[data-toggle]").on("click", function () {
    focusElement = document.activeElement;
    $($(this).data("target")).show();
    $($(this).data("target")).addClass("animate");
    $("body").addClass("modal-open");

    if ($('body').hasClass('modal-open')) {
        $('html').css({ 'height': '100%', 'overflow': 'hidden' });
    }

    $(".modal-backdrop").show();
    var modalid = $(this).attr('data-target');
    var modal = $(modalid);
    modal.find("button.close").focus();
    
    if ($(".cardListModal__popup.modal_container").hasClass('animate')) {
        setTimeout(function () {
            // add all the elements inside modal which you want to make focusable
            var focusableElements = 'button:not(.d-none), [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
            
            if (modalid !== undefined) {
                document.addEventListener('keydown', function (e) {
                    var modal = document.querySelector(modalid); // select the modal by it's id
                    var firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
                    var focusableContent = modal.querySelectorAll(focusableElements);
                    var lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
                    var isTabPressed = e.key === 'Tab' || e.keyCode === 9;
                    if (!isTabPressed) {
                        return;
                    }
                    if (e.shiftKey) { // if shift key pressed for shift + tab combination
                        if (document.activeElement === firstFocusableElement) {
                            lastFocusableElement.focus(); // add focus for the last focusable element
                            e.preventDefault();
                        }
                    } else { // if tab key is pressed
                        if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                            firstFocusableElement.focus(); // add focus for the first focusable element
                            e.preventDefault();
                        }
                    }
                });

            }
        }, 1200);
    }
});

$(".cardListModal__popup .close").on("click", function () {
    $(this).closest(".modal_container").hide();
    $(".modal-backdrop").hide();
    $(this).closest(".modal_container").removeClass("animate");
    $("body").removeClass("modal-open");

    if (!$('body').hasClass('modal-open')) {
        $('html').css({ 'height': 'unset', 'overflow': 'unset' });
    }

    focusLastActiveElement();
});

$(".cardListModal__popup").on("click", function (e) {
    if (!$(e.target).closest(".modal_body").length) {
        attachEventHandlerCustom(".cardListModal__popup", "backdropClick", true);
        $(".modal_container").hide();
        $(".modal-backdrop").hide();
        $(".modal_container").removeClass("animate");
        $("body").removeClass("modal-open");

        if (!$('body').hasClass('modal-open')) {
            $('html').css({ 'height': 'unset', 'overflow': 'unset' });
        }

        focusLastActiveElement();
    }
});

/*Analytics*/
analytics.eventConfig.push({
    "target": ".cardListModal_container",
    "codeId": "C04",
    "events": [
        {
            "eventTarget": ".cardListModal_container__child a:not([href*=\\http])",
            "eventType": "click",
            "tags": {
                "componentId": "c04",
                "componentName": "lightbox",
                "elementText": "",
                "destinationUrl": "",
                "event": "navigation",
                "eventType": "lightbox load click",
                "elementType": "lightbox link",
                "eventLabel": "",
                "fileName": "",
                "parentName": "Card List Modal collection",
                "parentOrdinal": "",
                "parentTitle": ""
            }
        },
        // need to check if this is needed
        {
            "eventTarget": ".cardListModal_container__child.cardListModal_link a[href^=http]",
            "eventType": "click",
            "tags": {
                "event": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "outbound"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "eventType": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "lightbox load outbound click"
                    },
                    {
                        "rule": "true",
                        "value": "lightbox load internal navigation click"
                    }
                ],

                "componentName": "lightbox",
                "componentId": "c04",
                "elementType": "lightbox link",
                "elementText": "",
                "eventLabel": "",
                "fileName": "",
                "destinationUrl": "",
                "parentName": "Card List Modal collection",
                "parentOrdinal": "",
                "parentTitle": ""
            }
        },
        // clicking the close icon
        {
            "eventTarget": ".cardListModal__popup .close",
            "eventType": "click",
            "tags": {
                "componentId": "c04",
                "componentName": "lightbox",
                "elementText": "",
                "destinationUrl": "",
                "event": "navigation",
                "eventType": "lightbox exit click",
                "elementType": "x out icon",
                "fileName": "",
                "parentName": "Card List Modal collection",
                "parentOrdinal": "",
                "parentTitle": ""
            }
        },
    ]
}, {
    "target": ".cardListModal__popup",
    "codeId": "C04",
    "events": [
        {
            "eventTarget": "backdropClick",
            "eventType": "click",
            "tags": {
                "componentId": "c04",
                "componentName": "lightbox",
                "elementText": "",
                "destinationUrl": "",
                "event": "navigation",
                "eventType": "lightbox exit click",
                "elementType": "outside click",
                "fileName": "",
                "parentName": "Card List Modal collection",
                "parentOrdinal": "",
                "parentTitle": ""
            }
        },
    ]
});